export default {
  allPayPeriods: (state) => state.payPeriods,
  payPeriodsLoading: (state) => state.payPeriodsLoading
}
